import {
  BasicButton,
  ButtonGroup,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

import { getNumMissingDocuments } from "./utils";

type IncompleteDocumentsModalProps = {
  documents: components["schemas"]["IdentificationDocumentsCheckField"]["value"];
  trigger: React.ReactElement;
  onNext: () => void;
};

export function IncompleteDocumentsModal({
  documents,
  trigger,
  onNext,
}: IncompleteDocumentsModalProps) {
  const { t } = useTranslation();

  const numMissingDocumentsText = useMemo(() => {
    const count = getNumMissingDocuments(documents);

    if (count === 4) {
      return t("all 4");
    }
    return `${count}`;
  }, [documents]);

  return (
    <ModalTrigger trigger={() => trigger}>
      {(close) => (
        <LegacyModal>
          <ModalHeader
            close={close}
            title={t("Your identification documents are incomplete")}
          />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>
                You are about to proceed without uploading{" "}
                {numMissingDocumentsText} of your identification documents.
                Meeting the requirements will produce quicker results.
              </Trans>
              <br />
              <br />
              <Trans>
                If you'd like to skip this step click 'Okay' and our team will
                contact you to help complete your check after submission.
              </Trans>
            </Text>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <BasicButton size="medium" onPress={close}>
                <Trans>Go back</Trans>
              </BasicButton>
              <PrimaryButton onPress={onNext} size="medium">
                <Trans>Okay</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
